import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_entity_sales_credit_terms_import_file_helper_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    file_import_hdr_guid: fromDatatype.GuidDataFieldInterface;
    customer_code: fromDatatype.VarcharArrayDatatypeInterface;
    credit_term_code: fromDatatype.VarcharArrayDatatypeInterface;
    credit_term_set_year: fromDatatype.IntegerDatatypeInterface;
    credit_term_set_month: fromDatatype.IntegerDatatypeInterface;
    credit_term_set_day: fromDatatype.IntegerDatatypeInterface;
    credit_term_add_year: fromDatatype.IntegerDatatypeInterface;
    credit_term_add_month: fromDatatype.IntegerDatatypeInterface;
    credit_term_add_day: fromDatatype.IntegerDatatypeInterface;
    short_error_message: fromDatatype.TextDatatypeInterface;
    error_stack_trace: fromDatatype.TextDatatypeInterface;
    validated: boolean;
    processed: boolean;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharArrayDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharArrayDatatypeInterface;
}

export class bl_fi_entity_sales_credit_terms_import_file_helper_RowClass implements bl_fi_entity_sales_credit_terms_import_file_helper_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    file_import_hdr_guid: fromDatatype.GuidDataFieldInterface;
    customer_code: fromDatatype.VarcharArrayDatatypeInterface;
    credit_term_code: fromDatatype.VarcharArrayDatatypeInterface;
    credit_term_set_year: fromDatatype.IntegerDatatypeInterface;
    credit_term_set_month: fromDatatype.IntegerDatatypeInterface;
    credit_term_set_day: fromDatatype.IntegerDatatypeInterface;
    credit_term_add_year: fromDatatype.IntegerDatatypeInterface;
    credit_term_add_month: fromDatatype.IntegerDatatypeInterface;
    credit_term_add_day: fromDatatype.IntegerDatatypeInterface;
    short_error_message: fromDatatype.TextDatatypeInterface;
    error_stack_trace: fromDatatype.TextDatatypeInterface;
    validated: boolean;
    processed: boolean;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharArrayDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharArrayDatatypeInterface;
}